














































































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// eslint-disable-next-line sort-imports
import { namespace, State } from "vuex-class";
import AppInput from "@/components/global/AppInput.vue";
import AppModal from "@/components/global/AppModal.vue";
import AppTextarea from "@/components/global/AppTextarea.vue";
import BlacklistModule from "@/store/modules/blacklist";
import { BlacklistPayload } from "@/models/blacklist/BlacklistPayload";
import { BlacklistReasons } from "@/models/blacklist/BlacklistReasons";
import { BlacklistState } from "@/models/store/BlacklistState";

const blacklist = namespace(BlacklistModule.name);

@Component({
  name: "BlacklistCreate",
  components: {
    AppInput,
    AppModal,
    AppTextarea,
    ValidationObserver,
    ValidationProvider
  }
})
export default class BlacklistCreate extends Vue {
  $refs!: {
    createTenantForm: HTMLFormElement;
  }
  // ===== Store ===== //
  @State("blacklist") private readonly blacklist!: BlacklistState;
  @blacklist.Action("createBlacklistTenant") public createBlacklistTenant!: (blackListPayload: BlacklistPayload) => void;

  // ===== Data ===== //
  public createBlacklistModal = false;
  public loading = false;
  public payload = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    drivers_license: "",
    location_code: "",
    reason_alias: "",
    note: ""
  };

  // ===== Methods ===== //
  public handleCreateTenantModal(): void {
    this.createBlacklistModal = true;
  }
  public handleCancelBlacklistTenant(): void {
    this.resetTenantPayload();
    (this.$refs.createTenantForm).reset();
    this.createBlacklistModal = false;
  }
  public async handleCreateBlacklistTenant(): Promise<void> {
    this.loading = true;
    const validated = await (this.$refs.createTenantForm).validate();
    if (!validated && !this.validFields) {
      this.loading = false;
    }
    const payload = {
      id: null,
      customer_name: `${this.payload.first_name} ${this.payload.last_name}`,
      email_address: this.payload.email,
      phone_number: this.payload.phone,
      drivers_license_number: this.payload.drivers_license,
      location_code: this.payload.location_code,
      reason_alias: this.payload.reason_alias,
      note: this.payload.note
    };

    if (validated && this.validFields) {
      await this.createBlacklistTenant(payload);
      await this.resetTenantPayload();
      (this.$refs.createTenantForm).reset();
      this.createBlacklistModal = false;
    }
    this.loading = false;
  }
  public resetTenantPayload() {
    this.payload.first_name = "";
    this.payload.last_name = "";
    this.payload.email = "";
    this.payload.phone = "";
    this.payload.drivers_license = "";
    this.payload.location_code = "";
    this.payload.reason_alias = "";
    this.payload.note = "";
  }

  // ===== Watchers ===== //

  // ===== Computed ===== //
  get blacklistReasons(): BlacklistReasons[] {
    return this.blacklist.blacklistReasons;
  }
  get facilities() {
    return this.$store.state.facility.facilitiesList;
  }
  get validFields(): boolean {
    return !!(this.payload.first_name &&
      this.payload.last_name &&
      this.payload.location_code &&
      this.payload.reason_alias);
  }
  get phoneRegex() {
    return /^[2-9][0-9-]{11,12}$/;
  }
}
